export const DRILLDOWN_SPORT_LEVEL_NUMBER = 2;
export const DRILLDOWN_COUNTRY_LEVEL_NUMBER = 3;
export const DRILLDOWN_LEAGUE_LEVEL_NUMBER = 4;

export const EVENT_DETAIL_SCROLL_THRESHOLD = 55;
